<template>
  <section>
    <p class="title is-1">Reporte de ventas</p>
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag="router-link" to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Ventas</b-breadcrumb-item>
      <b-breadcrumb-item tag="router-link" to="/reporte-ventas-usuario"
        >ReportePorUsuario</b-breadcrumb-item
      >
    </b-breadcrumb>

    <!-- Botón de reporte -->
    <button @click="mostrarReportePorProducto" class="button is-primary">
      <span class="icon">
        <i class="fas fa-file-alt"></i>
        <!-- Icono de reporte -->
      </span>
      <span>Generar Reporte</span>
    </button>
    <div v-if="transacciones.length > 0" class="card" id="pequeño">
      <b-table class="table is-small" :data="transacciones">
        <b-table-column field="ipo" label="Tipo" sortable v-slot="props">
          <span
            :class="{
              'fondo-rojo': props.row.tipo == 'salida',
              'fondo-verde': props.row.tipo == 'entrada',
            }"
          >
            {{ props.row.tipo }}
          </span>
        </b-table-column>
        <b-table-column field="nombreUsuario" label="Usuario" v-slot="props">
          {{ props.row.nombreUsuario }}
        </b-table-column>
        <b-table-column field="motivo" label="Motivo" v-slot="props">
          {{ props.row.motivo }}
        </b-table-column>
        <b-table-column field="valor" label="Valor" v-slot="props">
          ${{ parseInt(props.row.valor).toLocaleString("es-CO") }}
        </b-table-column>
      </b-table>
    </div>
    <busqueda-en-fecha @seleccionada="onBusquedaEnFecha" />
    <mensaje-inicial
      class="mt-2"
      :titulo="'Seleccione un periodo de ventas'"
      :subtitulo="'Aquí aparecerán las ventas registradas'"
      v-if="ventas.length < 1"
    />
    <div class="mt-2" v-if="ventas.length > 0">
      <cartas-totales :totales="totalesGenerales" />
      <b-select v-model="perPage">
        <option value="5">5 por página</option>
        <option value="10">10 por página</option>
        <option value="15">15 por página</option>
        <option value="20">20 por página</option>
      </b-select>

      <b-table
        class="box"
        :data="ventas"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :default-sort-direction="defaultSortDirection"
        :pagination-rounded="isPaginationRounded"
        :sort-icon="sortIcon"
        :sort-icon-size="sortIconSize"
        default-sort="user.first_name"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
      >
        <b-table-column
          v-if="this.fve === 'no'"
          field="id"
          label="Id Venta"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.id }}
        </b-table-column>

        <b-table-column
          field="fecha"
          label="Fecha"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.fecha }}
        </b-table-column>

        <b-table-column
          field="nombreCliente"
          label="Cliente"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.nombreCliente }}
        </b-table-column>

        <b-table-column
          field="nombreUsuario"
          label="Usuario"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.nombreUsuario }}
        </b-table-column>

        <b-table-column field="pagado" label="Pago" sortable v-slot="props">
          ${{ parseInt(props.row.pagado).toLocaleString("es-CO") }}
        </b-table-column>

        <b-table-column field="Cambio" label="Cambio" sortable v-slot="props">
          ${{
            parseInt(props.row.pagado - props.row.total).toLocaleString("es-CO")
          }}
        </b-table-column>

        <b-table-column field="total" label="Total" sortable v-slot="props">
          <b>${{ parseInt(props.row.total).toLocaleString("es-CO") }}</b>
        </b-table-column>

        <b-table-column
          field="productos"
          label="Productos"
          sortable
          v-slot="props"
        >
          <tabla-productos-vendidos
            :productos="props.row.productos"
            :viene="2"
          />
        </b-table-column>

        <b-table-column field="ticket" label="Comprobante" v-slot="props">
          <b-button
            type="is-info"
            icon-left="ticket-outline"
            @click="generarComprobante(props.row)"
            >Comprobante</b-button
          >

          <b-button
            type="is-danger"
            id="botoneliminar"
            @click="eliminarVenta(props.row)"
            >Eliminar</b-button
          >
        </b-table-column>
      </b-table>
    </div>
    <comprobante-compra
      :venta="this.ventaSeleccionada"
      :tipo="'venta'"
      :cufe="cufe"
      v-if="mostrarComprobante"
      @impreso="onImpreso"
    />
    <b-loading
      :is-full-page="true"
      v-model="cargando"
      :can-cancel="false"
    ></b-loading>
  </section>
</template>
<script>
import BusquedaEnFecha from "../Extras/BusquedaEnFecha";
import MensajeInicial from "../Extras/MensajeInicial";
import CartasTotales from "../Extras/CartasTotales";
import TablaProductosVendidos from "./TablaProductosVendidos";
import ComprobanteCompra from "./ComprobanteCompra";
import HttpService from "../../Servicios/HttpService";
import Utiles from "../../Servicios/Utiles";
import Swal from "sweetalert2"; // Importar SweetAlert2

export default {
  name: "ReporteVentas",
  components: {
    BusquedaEnFecha,
    TablaProductosVendidos,
    MensajeInicial,
    CartasTotales,
    ComprobanteCompra,
  },

  data: () => ({
    filtros: {
      fechaInicio: "",
      fechaFin: "",
    },
    cargando: false,
    ventas: [],
    isPaginated: true,
    isPaginationSimple: false,
    isPaginationRounded: true,
    paginationPosition: "bottom",
    defaultSortDirection: "asc",
    sortIcon: "arrow-up",
    sortIconSize: "is-medium",
    currentPage: 1,
    perPage: 5,
    totalesGenerales: [],
    mostrarComprobante: false,
    ventaSeleccionada: null,
    ventascajerofecha: [],
    isExpanded: false,
    transacciones: [],
    totalProductos: [],
    reporte: [],
    fechaInicio: "",
    fechaFin: "",
    cufe: "",
    datosNegocio: null,
    fve: "",
  }),

  async mounted() {
    await this.obtenerDatos(); // Espera a obtener los datos antes de llamar a obtenerVentas
    this.obtenerVentas();
    document.title = "Reporte Ventas";
  },

  methods: {
    async obtenerDatos() {
      this.cargando = true;
      try {
        const resultado = await HttpService.obtenerConConsultas("ajustes.php", {
          accion: "obtener",
        });
        this.datosNegocio = resultado;
        this.fve = resultado.correo === 1 ? "si" : "no";
      } catch (error) {
        console.error("Error obteniendo datos:", error);
      } finally {
        this.cargando = false;
      }
    },

    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    onImpreso(resultado) {
      this.mostrarComprobante = resultado;
    },

    generarComprobante(venta) {
      this.cufe = venta.cufe;
      this.mostrarComprobante = true;
      this.ventaSeleccionada = venta;
    },

    onBusquedaEnFecha(fechas) {
      // Establecer la fecha de inicio con la hora constante a las 05:00:00 en UTC
      const fechaInicio = new Date(fechas[0]);
      fechaInicio.setUTCHours(5, 0, 0, 0); // Establecer la hora a las 05:00:00 en UTC
      // Formatear la fecha y hora como cadena "YYYY-MM-DD HH:mm:ss"
      const fechaInicioString =
        fechaInicio.toISOString().split("T")[0] + " 05:00:00";
      this.filtros.fechaInicio = fechaInicioString;
      // Establecer la fecha de fin con la hora constante a las 05:00:00 en UTC
      const fechaFin = new Date(fechas[1]);
      fechaFin.setUTCHours(5, 0, 0, 0); // Establecer la hora a las 05:00:00 en UTC
      // Sumar un día a la fecha fin
      fechaFin.setUTCDate(fechaFin.getUTCDate() + 1);
      // Formatear la fecha y hora como cadena "YYYY-MM-DD HH:mm:ss"
      const fechaFinString = fechaFin.toISOString().split("T")[0] + " 05:00:00";
      this.filtros.fechaFin = fechaFinString;
      this.fechaInicio = fechaInicioString;
      this.fechaFin = fechaFinString;
      this.obtenerVentas();
      this.obtenerTransaciones();
    },

    eliminarVenta(row) {
      // Obtener la fecha actual en formato ddMMyyyy
      const today = new Date();
      const day = String(today.getDate()).padStart(2, "0");
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Enero es 0
      const year = today.getFullYear();
      const currentPassword = `${day}${month}${year}`; // Formato ddMMyyyy

      // Mostrar el SweetAlert2 de confirmación con campo de contraseña
      Swal.fire({
        title: `¿Estás seguro de que deseas eliminar la venta de ${row.nombreCliente}?`,
        text: `Total de la venta: ${row.total}`,
        icon: "warning",
        input: "password", // Campo para contraseña
        inputLabel: "Ingrese la contraseña",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        preConfirm: (password) => {
          // Validar la contraseña ingresada
          if (password !== currentPassword) {
            Swal.showValidationMessage(
              "Contraseña incorrecta. Inténtalo de nuevo."
            );
            return false; // Detener el proceso si la contraseña es incorrecta
          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          // Si el usuario ingresa la contraseña correcta, proceder con la eliminación
          HttpService.eliminar("vender.php", {
            accion: "eliminarVenta",
            id: row.id,
          }).then((resultado) => {
            if (!resultado) {
              this.$buefy.toast.open("Error al eliminar");
              this.cargando = false;
              return;
            }

            if (resultado) {
              this.cargando = false;
              this.$buefy.toast.open({
                type: "is-info",
                message: "Venta eliminada.",
              });
              this.obtenerVentas();
            }
          });
        }
      });
    },
    obtenerTransaciones() {
      let payload = {
        filtros: this.filtros,
        accion: "obtenerTransacciones",
      };
      HttpService.obtenerConConsultas("vender.php", payload).then(
        (transacciones) => {
          this.transacciones = transacciones;
          console.log(this.transacciones);
        }
      );
    },
    obtenerProductos() {
      let payload = {
        filtros: this.filtros,
        accion: "totalProductos",
      };
      HttpService.obtenerConConsultas("vender.php", payload)
        .then((resultado) => {
          this.totalProductos = resultado.totalp;
        })
        .catch((error) => {
          console.error("Error al obtener productos:", error);
        });
    },
    mostrarReportePorProducto() {
      const tablaHTML = `
    <style>
      table {
        width: 100%;
        border-collapse: collapse;
      }
      th, td {
        border: 1px solid black;
        padding: 8px;
        text-align: left;
      }
      th {
        background-color: #f2f2f2;
      }
    </style>
    <div style="text-align: center; margin-bottom: 20px;">
      <strong>Reporte de Ventas</strong><br>
      <span >Desde: ${this.fechaInicio} Hasta: ${this.fechaFin}</span>
    </div>
    <table class="table" style="font-size: 15px;">
      <thead>
        <tr>
          <th>Producto</th>
          <th>Cant</th>
          <th>Total</th>
          <th>Tipo</th>
        </tr>
      </thead>
      <tbody>
        ${this.reporte
          .map(
            (item) => `
          <tr>
            <td style="font-size: 13px;">${item.nombre_producto}</td>
            <td>${item.total_cantidad}</td>
            <td>$${parseInt(item.total_precio).toLocaleString("es-CO")}</td>
            <td>${item.tipo}</td>
          </tr>
        `
          )
          .join("")}
      </tbody>
    </table>
`;

      window.imprimirTabla = () => {
        const iframe = document.createElement("iframe");
        iframe.style.position = "absolute";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "none";
        document.body.appendChild(iframe);

        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write("<html><head><title>Reporte de Ventas</title>");
        doc.write("<style>");
        doc.write("table { width: 100%; border-collapse: collapse; }");
        doc.write(
          "th, td { border: 1px solid black; padding: 8px; text-align: left; }"
        );
        doc.write("th { background-color: #f2f2f2; }");
        doc.write("</style></head><body>");
        doc.write(tablaHTML);
        doc.write("</body></html>");
        doc.close();

        iframe.contentWindow.focus();
        iframe.contentWindow.print();

        // Remove the iframe after printing
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      };

      Swal.fire({
        title: "Reporte de Ventas",
        html:
          tablaHTML +
          '<br><button onclick="window.imprimirTabla()" class="button is-primary">Imprimir</button>',
        confirmButtonText: "Cerrar",
        customClass: {
          popup: "swal2-custom",
          confirmButton: "button is-primary",
        },
      });
    },
    obtenerVentas() {
      this.cargando = true;
      let fechaInicio = new Date();
      fechaInicio.setHours(5, 0, 0, 0); // Inicio del día a las 5:00 AM

      let fechaFin = new Date(fechaInicio);
      fechaFin.setDate(fechaFin.getDate() + 1); // Día siguiente
      fechaFin.setHours(4, 49, 0, 0); // Fin a las 4:49 AM

      let filtrosVacios =
        !this.filtros ||
        Object.keys(this.filtros).length === 0 ||
        (!this.filtros.fechaInicio && !this.filtros.fechaFin);

      let payload = {
        filtros: filtrosVacios
          ? {
              fechaInicio:
                fechaInicio.toISOString().split("T")[0] + " 05:00:00",
              fechaFin: fechaFin.toISOString().split("T")[0] + " 04:49:00",
            }
          : this.filtros,
        accion: "obtener_ventas",
        fdv: this.fve,
      };

      HttpService.obtenerConConsultas("vender.php", payload).then(
        (resultado) => {
          this.ventascajerofecha = resultado.ventacajeros;
          console.log(this.ventascajerofecha);
          this.ventas = resultado.ventas;
          this.reporte = resultado.totalProductos;
          this.totalesGenerales = [
            {
              nombre: "Total ventas",
              total:
                "$" + parseFloat(resultado.totalVentas).toLocaleString("es-CO"),
              clase: "has-text-success",
            },
            {
              nombre: "Efectivo",
              total:
                "$" +
                parseFloat(resultado.totalefectivo).toLocaleString("es-CO"),
              icono: "currency-usd",
              clase: "has-text-primary",
            },
            {
              nombre: "Bancolombia",
              total:
                "$" +
                parseFloat(resultado.totaltransferencia).toLocaleString(
                  "es-CO"
                ),
              icono: "bank",
              clase: "has-text-primary",
            },
            {
              nombre: "Tarjeta",
              total:
                "$" +
                parseFloat(resultado.totaltarjeta).toLocaleString("es-CO"),
              icono: "credit-card",
              clase: "has-text-primary",
            },
            {
              nombre: "Nequi",
              total:
                "$" + parseFloat(resultado.totalNequi).toLocaleString("es-CO"),
              icono: "card",
              clase: "has-text-primary",
            },
            {
              nombre: "Ganancia",
              total:
                "$" +
                Utiles.calcularTotalGanancia(this.ventas).toLocaleString(
                  "es-CO"
                ),
              icono: "chart-line",
              clase: "has-text-info",
            },
          ];

          this.cargando = false;
        }
      );
    },
  },
};
</script>

<style scoped>
.custom-table {
  border-collapse: collapse;
  width: 106%;
}

.custom-table th {
  border: 1px solid black;
  background-color: #f2f2f2;
  color: black;
  padding: 2px;
  text-align: left;
}

.custom-table td {
  border: 1px solid black;
  color: black;
  padding: 2px;
  font-size: 12px; /* Tamaño de fuente reducido */
}
.expand-button {
  cursor: pointer;
  padding: 4px;
  background-color: rgb(20, 19, 19);
  text-align: center;
  width: 20px;
  margin-bottom: 8px;
}

.expand-button span {
  font-weight: bold;
}

.expanded .custom-table {
  display: table;
}

.expanded .expand-button span {
  transform: rotate(-90deg);
}

#pequeño {
  max-width: 400px; /* Ajusta el ancho máximo según tu preferencia */
  margin: left; /* Centra la tarjeta en el contenedor */
  padding: 10px; /* Ajusta el relleno según tu preferencia */
}

#pequeño {
  width: 100%; /* Asegura que la tabla ocupe el 100% del ancho de la tarjeta */
}

.fondo-rojo {
  background-color: #f2a8a8; /* Puedes ajustar el color según tus preferencias */
}

.fondo-verde {
  background-color: #aaf2d8; /* Puedes ajustar el color según tus preferencias */
}
#reporteVentasTable {
  font-size: 14px; /* Tamaño de fuente más grande */
  width: 100%;
  margin-bottom: 1rem;
  background-color: #fff;
  color: #4a4a4a;
  border-collapse: collapse;
  border-spacing: 0;
}

#reporteVentasTable th,
#reporteVentasTable td {
  padding: 1rem; /* Aumentar el padding */
  vertical-align: top;
  border-top: 1px solid #eaeaea;
}

#reporteVentasTable th {
  font-weight: bold;
  background-color: #f9f9f9;
  text-align: center;
}

#reporteVentasTable td {
  text-align: left;
}

#reporteVentasTable tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.swal2-custom {
  width: 90%; /* Ancho personalizado del popup */
  margin-left: auto;
  margin-right: auto; /* Centrado horizontal del popup */
}
.button {
  margin-top: 1rem; /* Espacio adicional arriba del botón */
}
</style>

